import { useState, useEffect, useRef } from "react";
import "./Timer.css";

const MS_PER_DAY = 1000 * 60 * 60 * 24;
const MS_PER_HOUR = 1000 * 60 * 60;
const MS_PER_MIN = 1000 * 60;
const MS_PER_SEC = 1000;
const PAD = (n) => String(n).padStart(2, "0");
const COUNTDOWN_DAYS = 30;

function Timer() {
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
  const [expired, setExpired] = useState(false);
  const deadlineRef = useRef(null);

  useEffect(() => {
    const deadline = new Date();
    deadline.setDate(deadline.getDate() + COUNTDOWN_DAYS);
    deadlineRef.current = deadline.getTime();

    const tick = () => {
      const remaining = deadlineRef.current - Date.now();
      if (remaining <= 0) {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        setExpired(true);
        return;
      }
      setTimeLeft({
        days: PAD(Math.floor(remaining / MS_PER_DAY)),
        hours: PAD(Math.floor((remaining % MS_PER_DAY) / MS_PER_HOUR)),
        minutes: PAD(Math.floor((remaining % MS_PER_HOUR) / MS_PER_MIN)),
        seconds: PAD(Math.floor((remaining % MS_PER_MIN) / MS_PER_SEC)),
      });
    };

    tick();
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, []);

  if (expired) {
    return <p className="time-up">TIME IS UP</p>;
  }

  const units = [
    { id: "day", label: "Days", value: timeLeft.days },
    { id: "hour", label: "Hours", value: timeLeft.hours },
    { id: "minute", label: "Minutes", value: timeLeft.minutes },
    { id: "second", label: "Seconds", value: timeLeft.seconds },
  ];

  return (
    <div id="countdown" role="timer" aria-label="Countdown timer">
      {units.map(({ id, label, value }) => (
        <div key={id} className="col-4">
          <div className="box">
            <p id={id}>{value}</p>
            <span className="text">{label}</span>
          </div>
        </div>
      ))}
    </div>
  );
}

export default Timer;
